import React, { useState, Fragment } from 'react';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './DeclineModalComponent.css';
import declineShipmentModal from '../../assets/images/declineShipmentModal.png';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import xIcon from '../../assets/images/xmark.svg'
import { useDispatch } from 'react-redux';
import { cancelOrder, deleteOrderById, fetchOrders } from '../../redux/orderSlice';
import { declineShipment, fetchShipments, cancelShipment } from '../../redux/shipmentSlice';
import { SHIPMENT } from '../../helpers/commonName';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

const DeclineShipmentModalComponent = ({ isOpen, forModule, id, action, onClose }) => {
  console.log("isOpen",isOpen);
  const [open, setOpen] = React.useState(true);
  const [reasonText, setReasonText] = useState('');
  const dispatch = useDispatch()

  console.log("open",open);

  const handleTextChange = (e) => {
    setReasonText(e.target.value);
  };

  const handleSubmit = () => {
    console.log('Text submitted:', reasonText, forModule, id);
    let queryParams;
    switch(forModule){
      case 'Order': 
       queryParams ={
        orderId:id,
        action: "cancel",
        cancelReason :reasonText
      }
  
      dispatch(cancelOrder(queryParams)).then(() => {
        const queryParams = {
          type: 'outgoing',
          searchText: '',
          fromDate: '',
          toDate: '',
          pageSize:12,
          pageNumber:1,
        };
       dispatch(fetchOrders(queryParams))
      });
      break;
      case 'Shipment':
         queryParams ={
          shipmentId:id,
          action: action,
          reason :reasonText
        }
        if(action === SHIPMENT.REJECT_SHIPMENT){
          dispatch(declineShipment(queryParams)).then(() => {
            const queryParams = {
              type: 'incoming',
              searchText: '',
              fromDate: '',
              toDate: '',
              pageSize:12,
              pageNumber:1,
              shipmentStatus: ''
            };
           dispatch(fetchShipments(queryParams))
          });
        } else {
          dispatch(cancelShipment(queryParams)).then(() => {
            const queryParams = {
              type: 'outgoing',
              searchText: '',
              fromDate: '',
              toDate: '',
              pageSize:12,
              pageNumber:1,
              shipmentStatus: ''
            };
           dispatch(fetchShipments(queryParams))
          });
        }
        break;
    }
    
    
    handleClose();
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    // setOpen(false);
    onClose(false)
  };
  console.log('>>> :: DecLine :: <<<', forModule, id,action)

  return (
    <div>
      <Fragment >
        {/* <Button variant="outlined" onClick={handleClickOpen}>
          Decline  {forModule}
        </Button> */}
          {/* <button className="icon-clay delete" onClick={handleClickOpen}>
              <span class="inner-clay color-red"> <img src={xIcon} alt="Cancel" /></span>
            </button> */}
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={isOpen}
          className='shipmentDeclineModalBody'

        >
          <DialogTitle sx={{ m: 0, p: "0px 39px " }} id="customized-dialog-title">
            {/* Modal title */}
            <div className='modalImagediv'>
              <img
                className='modalImage'
                src={declineShipmentModal}
              />
              { action === SHIPMENT.CANCEL_SHIPMENT ? 
               <h4 className='headingForDeclineShipmentModal'> Cancel {forModule} </h4> :
               <h4 className='headingForDeclineShipmentModal'> Decline {forModule} </h4>
              }
            </div>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
              backgroundColor: "white",
              height: "7%",
              width: "6%",
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <Typography gutterBottom>
            { action === SHIPMENT.CANCEL_SHIPMENT ? 
               <h4 className='titleHeadingForModal'>Please provide reason for cancelling this {forModule}</h4> :
               <h4 className='titleHeadingForModal'>Please provide reason for declining this {forModule}</h4>
              }
              <div className='shipmentDeclineModalTextField'>
                <TextField
                  label="Enter here"
                  variant="outlined"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "80px",
                      marginTop: "5px"
                    },
                  }}

                  value={reasonText}
                  onChange={handleTextChange}
                  margin="normal"
                />
              </div>
            </Typography>

          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleSubmit} variant="contained" color="primary"
              style={{ width: "400px", marginRight: "19%", marginLeft: "20%", backgroundColor: "lightgrey", textDecoration: "white" }}
            >
              { action === SHIPMENT.CANCEL_SHIPMENT ? 
              `Cancel ${forModule}` :
              `Decline ${forModule}`}
            </Button>
          </DialogActions>
        </BootstrapDialog>
      </Fragment>
    </div>
  );
}
export default DeclineShipmentModalComponent